import  { useState, useEffect } from "react";
import {useLocation} from "react-router-dom";


function useUserLang() {
    const [userLang, setUserLang] = useState(localStorage.getItem("userLang")||"gr");
    const location = useLocation();
    useEffect(() => {
        const storedLang=localStorage.getItem("userLang");
        if(!storedLang){
            //alert("setting default lang");
            setUserLang("gr");
        }else{
            //alert("got a saved lang");
        }
      }, [])

      useEffect(()=>{
            localStorage.setItem("userLang",userLang);
      },[userLang])

      useEffect(()=>{
        const searchParams = new URLSearchParams(location.search).get("lang");
        if(searchParams==="gr" || searchParams==="en"){
            setUserLang(searchParams);
        }
    },[location]);
    //alert("UserLang.userlang:"+userLang)
    const changeUserLang=((newVal)=>{
        setUserLang(newVal);
    })

    return {userLang,changeUserLang};
}

export default useUserLang;
